import {combineReducers} from 'redux';
import {createReducer} from './utilities';

import {RESET_APP, SET_APP_TITLE, SET_APP_LOCALE, scope} from '../actions/app';

import onSite from './app/onSite';
import statistics from './app/statistics';
import support from './app/support';
import tools from './app/tools';
import other from './app/other';
import mpt from './app/mpt';
import alertMPG from './app/alertMPG';
import jerseys from './app/jerseys';
import notificationsCenter from './app/notificationsCenter';
import players from './app/players';
import dailyReport from './app/dailyReport';
import playerPool from './app/playerPool';
import uberEats from './app/uberEats';
import championships from './app/championships';
import mxi from './app/mxi';

const initialAppPropertiesState = {
  locale: 'en',
  title: 'MPG Admin',
};

function resetApp() {
  return initialAppPropertiesState;
}

function setAppLocale(state, action) {
  return {
    ...state,
    locale: action.locale,
  };
}

function setAppTitle(state, action) {
  return {
    ...state,
    title: action.title,
  };
}

const properties = createReducer(
  initialAppPropertiesState,
  {
    [RESET_APP]: resetApp,
    [SET_APP_LOCALE]: setAppLocale,
    [SET_APP_TITLE]: setAppTitle,
  },
  scope,
);

export default combineReducers({
  onSite,
  properties,
  statistics,
  support,
  tools,
  other,
  mpt,
  alertMPG,
  jerseys,
  notificationsCenter,
  players,
  dailyReport,
  playerPool,
  uberEats,
  championships,
  mxi,
});



// WEBPACK FOOTER //
// ./src/reducers/app.js